import { useEffect, useState } from "react";


const Loading = ({time = 70, variant = 1}) => {

    const [progress, setProgress] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            if (progress < 100) {
                setProgress(prev => prev + 15);
            } else {
                setProgress(0);
            }
        }, time);

        return () => clearInterval(interval); // Limpiar el intervalo cuando el componente se desmonta

    }, [progress]);

    return (
        <div className="p-4" style={{
            clipPath: "polygon(7% 19%, 93% 0, 100% 100%, 3% 88%)",
            // background: "#FC620A",
            background: variant == 1 ? "#FC620A" : "#A349FE",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate( -50%, -50%)"
        }}>
            <div className={`${variant == 1 ? "loader-container" : "loader-container2" }`}>
                <div className=" bg-white" style={{ width: `100%`, height: "100%" }}>
                    <div className={`${variant == 1 ? "loading-bar" : "loading-bar2"}`} style={{ width: `${progress}%` }}></div>
                </div>
                <span className={`${variant == 1 ? "loading-text" : "loading-text2" } fs-1`} >Cargando</span>
            </div>

        </div>
    );
};
export default Loading;